import { render, staticRenderFns } from "./nav-menu-item.vue?vue&type=template&id=172e1bd2"
import script from "./nav-menu-item.vue?vue&type=script&lang=js"
export * from "./nav-menu-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports